export const messages = {
  en: {
    editAllocationStorehouseApply: {
      title: 'Allocation Application',
      back: 'Back',
      applyRemark: 'Application Description',
      remarkPlaceholder: 'Required, please fill in the application description',
      purchaseItems: 'Purchase Items',
      select: 'Select',
      resourceType: 'Resource Type',
      resourceName: 'Resource Name',
      specification: 'Specification',
      isFixed: 'Fixed Resource',
      sourceWarehouse: 'Source Warehouse',
      referencePrice: 'Reference Price',
      selectPrice: 'Select Price',
      stock: 'Stock',
      targetWarehouse: 'Target Warehouse',
      selectTargetWarehouse: 'Required, select target warehouse',
      allocationQuantity: 'Allocation Quantity',
      allocationQuantityPlaceholder: 'Required, fill in allocation quantity',
      operation: 'Operation',
      cancelAllocation: 'Cancel Allocation',
      submit: 'Submit',
      noPurchaseItems: 'No purchase items selected',
      updateSuccess: 'Update successful',
      updateFailed: 'Update failed'
    }
  },
zh: {
    editAllocationStorehouseApply: {
      title: '調撥申請',
      back: '返回',
      applyRemark: '申請說明',
      remarkPlaceholder: '必填，請填寫申請說明',
      purchaseItems: '採購物品',
      select: '選擇',
      resourceType: '物品類型',
      resourceName: '物品名稱',
      specification: '物品規格',
      isFixed: '固定物品',
      sourceWarehouse: '源倉庫',
      referencePrice: '參考價格',
      selectPrice: '請選擇價格',
      stock: '庫存',
      targetWarehouse: '目標倉庫',
      selectTargetWarehouse: '必填，請選擇目標倉庫',
      allocationQuantity: '調撥數量',
      allocationQuantityPlaceholder: '必填，請填寫調撥數量',
      operation: '操作',
      cancelAllocation: '取消調撥',
      submit: '提交',
      noPurchaseItems: '未選擇採購物品',
      updateSuccess: '修改成功',
      updateFailed: '修改失敗'
    }
  },
  'zh-TW': {
    editAllocationStorehouseApply: {
      title: '調撥申請',
      back: '返回',
      applyRemark: '申請說明',
      remarkPlaceholder: '必填，請填寫申請說明',
      purchaseItems: '採購物品',
      select: '選擇',
      resourceType: '物品類型',
      resourceName: '物品名稱',
      specification: '物品規格',
      isFixed: '固定物品',
      sourceWarehouse: '源倉庫',
      referencePrice: '參考價格',
      selectPrice: '請選擇價格',
      stock: '庫存',
      targetWarehouse: '目標倉庫',
      selectTargetWarehouse: '必填，請選擇目標倉庫',
      allocationQuantity: '調撥數量',
      allocationQuantityPlaceholder: '必填，請填寫調撥數量',
      operation: '操作',
      cancelAllocation: '取消調撥',
      submit: '提交',
      noPurchaseItems: '未選擇採購物品',
      updateSuccess: '修改成功',
      updateFailed: '修改失敗'
    }
  }
}